// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"436ef7e5","646":"e2bc655b"}[chunkId] + ".chunk.css";
};